import { render, staticRenderFns } from "./PrintInvoicePopup.vue?vue&type=template&id=04986a94&scoped=true"
import script from "./PrintInvoicePopup.vue?vue&type=script&lang=js"
export * from "./PrintInvoicePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04986a94",
  null
  
)

export default component.exports